module.exports = __webpack_public_path__ + "img/wordle.83267a47.png";